import { createContext, useState } from "react";
import TeethChart from "./components/TeethChart";
import DentalTable from "./components/DentalForm/components/DentalTable";
import { FormProvider, useForm } from "react-hook-form";
import { Tooth } from "./components/DentalForm/components/Types";
export  type TeethSectionType = {
  l1: boolean;
  l2: boolean;
  r1: boolean;
  r2: boolean;
  c: boolean;
};
export type TeethContextType = {
  selectedTooth: { [key: string]:Tooth }; // Object where key is a string (e.g. "teeth18") and value is a Teeth object
  setSelectedTooth: React.Dispatch<React.SetStateAction<{ [key: string]:Tooth }>>;
  edit:any,
  setEdit:React.Dispatch<React.SetStateAction<any>>;
  saveFlag:boolean
  setSaveFlag:React.Dispatch<React.SetStateAction<any>>;
};
const defaultContextValue: TeethContextType = {
  selectedTooth: {},
  setSelectedTooth: () => {},
  edit:{},
  setEdit:()=>{},
  saveFlag:false,
  setSaveFlag:()=>{}
};
export const TeethContextV1 = createContext<TeethContextType>(defaultContextValue);
const DentalProcedureV1 = () => {
  const [selectedTooth, setSelectedTooth] = useState  ({})
  const [saveFlag,setSaveFlag]=useState<boolean>(false)
  const [edit,setEdit]=useState({})
  const method=useForm()
  return (
    <TeethContextV1.Provider value={{ selectedTooth, setSelectedTooth,edit,setEdit ,saveFlag,setSaveFlag}}>
        <FormProvider {...method}>
              <TeethChart />
              <DentalTable/>
        </FormProvider>
    </TeethContextV1.Provider>
  );
};
export default DentalProcedureV1;
